export default function FormatOddsDescription() {
    return (
        <>
            <p>
                The <b>formatOdds</b> function returns the value of the rawOdds
                in a specific odds format determined by the <b>oddsFormat</b>{' '}
                parameter
            </p>
            <p>
                You can find below an example of the input data necessary for
                formatOdds function
            </p>
        </>
    );
}
